var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31259 11.5102L8.49259 13.6802C8.62634 13.8172 8.79357 13.917 8.97773 13.9696C9.16189 14.0223 9.3566 14.0259 9.54259 13.9802C9.72974 13.9366 9.90255 13.8457 10.0444 13.7161C10.1863 13.5865 10.2924 13.4226 10.3526 13.2402L13.9326 2.51015C14.0073 2.3091 14.0227 2.09083 13.977 1.88128C13.9313 1.67172 13.8264 1.4797 13.6747 1.32804C13.523 1.17638 13.331 1.07145 13.1215 1.02574C12.9119 0.980021 12.6936 0.995437 12.4926 1.07015L1.76259 4.65015C1.57384 4.71462 1.40573 4.82833 1.27564 4.97952C1.14554 5.13071 1.05818 5.3139 1.02259 5.51015C0.985848 5.68864 0.994027 5.87346 1.04639 6.04801C1.09876 6.22256 1.19366 6.38136 1.32259 6.51015L4.06259 9.25015L3.97259 12.7202L6.31259 11.5102Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6125 1.29102L4.0625 9.25102",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ec989ae59bf3264558cb2f4c0a922171.svg";
export { ForwardRef as ReactComponent };